import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getImoveis } from '../services/api';
import ImovelCard from '../components/ImovelCard';
import Filtros from '../components/Filtros';
import EditarImoveisModal from '../components/EditarImoveisModal';
import { logImovelSearch } from '../utils/analytics';
import { FaEdit } from 'react-icons/fa';
import './Imoveis.css';

const Imoveis = () => {
  const [searchParams] = useSearchParams();
  const [imoveis, setImoveis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showEditModal, setShowEditModal] = useState(false);
  const isAuthenticated = localStorage.getItem('token');
  
  // Função para obter limites de área baseado no tipo
  const getAreaLimits = (tipo) => {
    if (tipo === 'Chácara') {
      return { min: 1000, max: 10000 };
    } else {
      return { min: 20, max: 500 };
    }
  };

  const tipoInicial = searchParams.get('tipo') || '';
  const areaLimitsInicial = getAreaLimits(tipoInicial);

  // Filtros temporários (que o usuário está editando)
  const [tempFilters, setTempFilters] = useState({
    operacao: 'venda', // Sempre venda
    tipo: tipoInicial,
    cidade: searchParams.get('cidade') || '',
    bairro: searchParams.get('bairro') || '',
    quartos: searchParams.get('quartos') || '',
    banheiros: searchParams.get('banheiros') || '',
    vagas: searchParams.get('vagas') || '',
    precoMin: searchParams.get('precoMin') || '50000',
    precoMax: searchParams.get('precoMax') || '4000000',
    areaMin: searchParams.get('areaMin') || String(areaLimitsInicial.min),
    areaMax: searchParams.get('areaMax') || String(areaLimitsInicial.max),
    novo: searchParams.get('novo') || '',
    usado: searchParams.get('usado') || '',
    disponivel: 'true'
  });

  // Filtros aplicados (usados na busca)
  const [appliedFilters, setAppliedFilters] = useState(tempFilters);

  // Busca inicial quando a página carrega ou quando appliedFilters muda
  useEffect(() => {
    loadImoveis();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appliedFilters]);

  const loadImoveis = async () => {
    try {
      setLoading(true);
      const response = await getImoveis(appliedFilters);
      setImoveis(response.data);
    } catch (error) {
      console.error('Erro ao carregar imóveis:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (newFilters) => {
    setTempFilters(newFilters);
  };

  const handleSearch = () => {
    setAppliedFilters({ ...tempFilters });
    // Rastrear busca de imóveis
    logImovelSearch(tempFilters);
  };

  if (loading) {
    return <div className="loading">Carregando imóveis...</div>;
  }

  return (
    <div className="imoveis-page">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h1 className="page-title">Buscar Imóvel</h1>
        {isAuthenticated && (
          <button 
            className="btn-add" 
            onClick={() => setShowEditModal(true)}
            style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
          >
            <FaEdit /> Editar
          </button>
        )}
      </div>

      <Filtros filters={tempFilters} onFilterChange={handleFilterChange} onSearch={handleSearch} />

      <div className="results-header">
        <p className="results-count">
          {imoveis.length} {imoveis.length === 1 ? 'imóvel encontrado' : 'imóveis encontrados'}
        </p>
      </div>

      {imoveis.length === 0 ? (
        <div className="no-results">
          <p>Nenhum imóvel encontrado com os filtros selecionados.</p>
          <p>Tente ajustar os filtros de busca.</p>
        </div>
      ) : (
        <div className="imoveis-grid">
          {imoveis.map(imovel => (
            <ImovelCard key={imovel.id} imovel={imovel} showEditButton={true} />
          ))}
        </div>
      )}

      <EditarImoveisModal
        isOpen={showEditModal}
        onClose={() => setShowEditModal(false)}
        imoveisList={imoveis}
        onSave={(novosImoveis) => {
          setImoveis(novosImoveis);
        }}
      />
    </div>
  );
};

export default Imoveis;

